<template>
  <vs-row>
    <vs-col>
      <div class="m-dashboard-menu px-4 mb-4">
        <router-link v-for="menu in mobileCardMenus" :to="menu.url || '/'" class="item" style="background: #fff;">
          <div>
            <div class="mt-4 mb-2 flex justify-center">
              <feather-icon :icon="menu.icon" />
            </div>
            <div class="text-center">
              <span style="font-size:1.125rem; font-weight: 500; color: #353535;">{{menu.name}}</span>
            </div>
          </div>
        </router-link>

      </div>
      <vs-card class="m-alarm-list mx-4">
        <div>
          <h5><i class="dot"></i>알림현황 <span>(최근 {{alertList.length}}건)</span> </h5>
        </div>
        <div v-for="alert in alertList" class="mt-3 p-3 board" @click="onClickAlert(alert)">
          <p style="font-size: 13px; color: #000; font-weight: 400">{{alert.message}}</p>
          <p class="mt-2" style="font-size: 12px; color: #696D71; font-weight: 400">{{alert.created_at}}</p>
        </div>
        <div v-if="alertList.length === 0" class="mt-3 p-6 board">
          <p style="font-size: 13px; color: #000; font-weight: 400">미확인 알림이 없습니다</p>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import HomeNotificationCard from '@/components/HomeNotificationCard'
import CommunityHealthinfoCard from '@/components/CommunityHealthinfoCard'
import CommunityWorkNewsCard from '@/components/CommunityWorkNewsCard'
import CommunityBusinessNewsCard from '@/components/CommunityBusinessNewsCard'
import HealthSafetyBudgetExecutionRateChart from '@/views/graph/HeathSafetyBudgetExecutionRateChart'
import sidebarItems from "@/layouts/sidemenu/main";

export default {
  components: {
    HealthSafetyBudgetExecutionRateChart,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard
  },
  data () {
    return {
      // mobileCardMenus: [
      //   {
      //     url: {name: 'project-home', params:{proj_id: 2}},
      //     name: '내부종사자 분야',
      //     icon: 'UsersIcon',
      //     activeCode: '',
      //     project_type: '내부종사자 분야',
      //   },
      //   {
      //     url: {name: 'project-home', params:{proj_id: 5}},
      //     name: '중대시민재해 분야',
      //     icon: 'ShieldIcon',
      //     activeCode: '',
      //     project_type: '중대시민재해 분야',
      //   },
      // ],
      successLoadGraph: false,
      alertList: [],
    }
  },
  computed:{
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    username () {
      return this.myInfo ? this.myInfo.username : ''
    },
    /**
     * src/layouts/sidemenu/main.js 파일에 정의된 프로젝트 목록에 대해서, 메뉴에 맞는 아이콘을 설정한다.
     * 만약 main.js 파일에 정의되지 않은 프로젝트가 있을 경우, 메뉴 마지막에 추가한다.
     *
     * @returns {*[]}
     */
    mobileCardMenus() {
      // API를 통해 불러온 프로젝트 목록
      const projects = this.myProjectList;
      const projectIds = projects.map((project) => project.id);
      const foundProjectIds = [];

      // 사이드 메뉴에 그려질 메뉴 아이템들
      const menuItems = [];

      for (const menu of sidebarItems) {
        let isFound = false;
        for (const proj of projects) {
          if (menu.url.params && menu.url.params.proj_id) {
            if (`${menu.url.params.proj_id || 0}` === `${proj.id}`) {
              menu.name = proj.field_name;
              isFound = true;
              foundProjectIds.push(proj.id);
              break;
            }
          }
        }

        if (isFound) {
          menuItems.push(menu);
        }
      }

      // projectIds 중에, foundProjectIds에 없는 것들을 items 마지막에 추가한다
      for (const projectId of projectIds) {
        if (!foundProjectIds.includes(projectId)) {
          const notFoundProject = projects.find((project) => project.id === projectId);
          if (notFoundProject) {
            menuItems.push({
              url: {
                name: "project-home",
                params: {proj_id: projectId},
              },
              name: notFoundProject.field_name,
              icon: "UsersIcon",
            });
          }
        }
      }

      // 만약 menuItems 배열이 비어있다면, 메뉴가 없다는 것을 의미한다.
      if (menuItems.length === 0) {
        menuItems.push({
          url: null,
          name: "참여한 분야가 없습니다",
          icon: "XOctagonIcon",
        });
      }

      return menuItems;
    },
    myProjectList() {
      try {
        return this.$store.state.member.memberInfo.projects ? this.$store.state.member.memberInfo.projects : [];
      } catch (e) {
        return [];
      }
    },
  },
  async created () {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(value => {
      this.successLoadGraph = true
    });
  },
  mounted () {
  },
  methods: {
    async loadAlertList () {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      }
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch('approval/LOAD_NOTIFICATION_LIST', options)

      const readList = this.$store.state.approval.alertReadList
      const unreadList = this.$store.state.approval.alertUnReadList

      this.alertList = unreadList
    },

    onClickAlert (alert) {
      const data = JSON.parse(alert.data)
      if (data && data.project_id && data.board_id && data.post_id) {
        const projectId = data.project_id
        const boardId = data.board_id
        const postId = data.post_id
        this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`});
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  .item {
    padding: 0.5rem;
    min-height: 100px;
    margin-bottom: 0.0rem;
    box-shadow: 0px 2px 8px 0px #00000021;
    border-radius: 8px;
  }

  @media (min-width: 960px) {
    .item {
      padding: 2.5rem 0.5rem;
    }
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
.m-alarm-list {
  width: auto;
  .board {border: 1px solid #CDCDCD;}
}
</style>
